// Copyright (c) 2026 Goffy. All Rights Reserved.

import { StyleSheet } from 'react-native';

import appColors from '@/theme/colors';

export const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: appColors.background.app,
  },
  intro: {
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 4,
  },
  introText: {
    color: appColors.text.muted,
    fontSize: 13,
    lineHeight: 18,
  },
  list: {
    flex: 1,
  },
  listContent: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 16,
    gap: 10,
  },
  bubble: {
    borderRadius: 12,
    paddingHorizontal: 12,
    paddingVertical: 10,
    maxWidth: '92%',
  },
  playerBubble: {
    alignSelf: 'flex-end',
    backgroundColor: appColors.surface.input,
    borderWidth: 1,
    borderColor: appColors.accent.primary,
  },
  refereeBubble: {
    alignSelf: 'flex-start',
    backgroundColor: appColors.surface.alt,
    borderWidth: 1,
    borderColor: appColors.border.default,
  },
  playerText: {
    color: appColors.text.primary,
    fontSize: 15,
    lineHeight: 21,
  },
  thinking: {
    color: appColors.text.muted,
    fontSize: 14,
    fontStyle: 'italic',
  },
  empty: {
    paddingHorizontal: 16,
    paddingTop: 24,
    gap: 10,
  },
  emptyTitle: {
    color: appColors.text.primary,
    fontSize: 16,
    fontWeight: '700',
  },
  suggestion: {
    borderWidth: 1,
    borderColor: appColors.border.default,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: appColors.surface.alt,
  },
  suggestionText: {
    color: appColors.text.primary,
    fontSize: 14,
  },
  error: {
    marginHorizontal: 16,
    marginBottom: 8,
    color: appColors.status.danger,
    fontSize: 14,
  },
  composer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 8,
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 12,
    borderTopWidth: 1,
    borderTopColor: appColors.border.default,
  },
  input: {
    flex: 1,
    // Without this a flex child refuses to shrink below its content width, which pushes the send
    // button off a narrow screen.
    minWidth: 0,
    maxHeight: 110,
  },
  disclaimer: {
    paddingHorizontal: 16,
    paddingBottom: 10,
    color: appColors.text.muted,
    fontSize: 11,
    lineHeight: 15,
  },
  historyHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  headerActions: {
    flexDirection: 'row',
    gap: 8,
    flexShrink: 1,
  },
  /**
   * GoffyButton's `compact` size is a fixed 190px; two of them plus the screen padding overflow a
   * 375pt phone and the second one gets clipped off the right edge. These buttons hold one short
   * word, so let them size to their text instead.
   */
  autoWidthButton: {
    width: 'auto',
    minWidth: 0,
    paddingHorizontal: 18,
    flexShrink: 1,
  },
  historyTitle: {
    color: appColors.text.muted,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  historyRow: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: appColors.border.default,
  },
  historyRowText: {
    color: appColors.text.primary,
    fontSize: 14,
  },
});

/** Plain object, not StyleSheet.create — markdown-display merges these into its own rule styles. */
export const answerMarkdownStyles = {
  body: { margin: 0, padding: 0 },
  paragraph: { marginTop: 0, marginBottom: 8 },
  text: { color: appColors.text.primary, fontSize: 15, lineHeight: 21 },
  strong: { fontWeight: '700' as const },
  bullet_list: { marginTop: 2, marginBottom: 6 },
  ordered_list: { marginTop: 2, marginBottom: 6 },
  list_item: { marginTop: 0, marginBottom: 2 },
  link: { color: appColors.accent.primary, textDecorationLine: 'underline' as const },
};
